import JoinStrings from './JoinStrings';

export default (name, type, stopCode, address) => {
  let returnText;
  switch (type) {
    case 'GTFS':
      returnText = `${stopCode ?? ''} - ${name}`;
      break;
    case 'POI':
      returnText = JoinStrings([name, address?.street, address?.locality, address?.place, address?.postcode]);
      break;
    case 'ADDRESS':
      returnText = JoinStrings([name, address?.locality, address?.place, address?.postcode]);
      break;
    default:
      returnText = '';
  }

  return returnText;
};
